import styles from './Section.module.css';

interface SectionProps {
  children: React.ReactNode;
  variant?: 'light' | 'gray' | 'dark' | 'blue';
  className?: string;
  id?: string;
}

export function Section({ children, variant = 'light', className = '', id }: SectionProps) {
  return (
    <section id={id} className={`${styles.section} ${styles[variant]} ${className}`.trim()}>
      {children}
    </section>
  );
}
